<template>
    <div class="container">

        <!-- Page Title -->
        <div class="page-title pl-0" v-if="user">
            <h1>{{ user.name }}</h1>
            <h4>{{ user.role.title }}</h4>
        </div>

        <!-- Links -->
        <div class="row">
            <div class="col-md-12 mb-2">

                <!-- Job search -->
                <job-search-card v-if="isSuperAdmin"></job-search-card>

                <!-- Technician links -->
                <template v-if="isTechnician">

                    <!-- Next Job -->
                    <router-link :to="{name: 'job', params: {jobId:jobs[0].id}}" v-if="jobs && jobs.length > 0" class="card card-body card-link">
                        <dl>
                            <dt>Next job</dt>
                            <dd>{{jobs[0].start_time}} - {{jobs[0].end_time}} <span class="font-weight-normal ml-2" v-if="jobs[0].first_name || jobs[0].second_name">{{jobs[0].first_name}} {{jobs[0].second_name}}</span></dd>
                        </dl>
                    </router-link>

                    <div class="card-grid grid-col-sm-2 grid-col-lg-3">

                        <!-- Today's Repair Jobs -->
                        <div class="card-link-container">
                            <router-link :to="{ name: 'jobList'}" class="card card-body card-link vertical">
                                <span class="badge badge-red count-badge" v-if="jobs && jobs.length">{{ jobs.length }}</span>
                                <icon-tools size="2x"></icon-tools>
                                <h5>Today's repair jobs</h5>
                            </router-link>
                        </div>

                        <!-- Daily Checklist -->
<!--                        <div class="card-link-container">-->
<!--                            <router-link :to="{ name: 'dailyChecklist'}" class="card card-body card-link vertical">-->
<!--                                <span class="badge badge-red count-badge">8</span>-->
<!--                                <icon-calendar-check size="2x"></icon-calendar-check>-->
<!--                                <h5>Daily checklist</h5>-->
<!--                            </router-link>-->
<!--                        </div>-->

                        <!-- Inbound Shipments -->
                        <div class="card-link-container">
                            <router-link :to="{ name: 'technicianInboundShipments'}" class="card card-body card-link vertical">
                                <icon-inbound-shipment size="2x"></icon-inbound-shipment>
                                <h5>Inbound shipments</h5>
                            </router-link>
                        </div>

                        <!-- Outbound Shipments -->
                        <div class="card-link-container">
                            <router-link :to="{ name: 'technicianOutboundShipments'}" class="card card-body card-link vertical">
                                <icon-outbound-shipment size="2x"></icon-outbound-shipment>
                                <h5>Outbound shipments</h5>
                            </router-link>
                        </div>

                        <!-- Pending in-house repairs -->
                        <div class="card-link-container" v-if="isInHouseTechnician"><!-- TODO: Only show for  in-house technicians -->
                            <router-link :to="{ name: 'inHouseRepairs'}" class="card card-body card-link vertical">
                                <icon-in-house-repair size="2x"></icon-in-house-repair>
                                <h5>Pending in-house repairs</h5>
                            </router-link>
                        </div>
                    </div>
                </template>

                <!-- Stock picking links -->
                <template v-if="isSuperAdmin">
                    <div class="card-grid grid-col-sm-2 grid-col-md-4">

                        <!-- Repair Kit Picking -->
                        <div class="card-link-container">
                            <router-link :to="{ name: 'repairKitPicking'}" class="card card-body card-link vertical">
                                <span class="badge badge-red count-badge" v-if="repairKitsToBePicked.length">{{ repairKitsToBePicked.length }}</span>
                                <icon-stock-pick size="2x"></icon-stock-pick>
                                <h5>Repair kit picking</h5>
                            </router-link>
                        </div>

                        <!-- Repair Kit Packing -->
                        <div class="card-link-container">
                            <router-link :to="{ name: 'repairKitPacking'}" class="card card-body card-link vertical">
                                <span class="badge badge-red count-badge" v-if="repairKitsPicked.length">{{ repairKitsPicked.length }}</span>
                                <icon-repair-kits-packing size="2x"></icon-repair-kits-packing>
                                <h5>Repair kit packing</h5>
                            </router-link>
                        </div>

                        <!-- Asset IMEI Search -->
                        <div class="card-link-container">
                            <router-link :to="{ name: 'bulkRepairImeiSearch'}" class="card card-body card-link vertical">
                                <icon-search-imei size="2x"></icon-search-imei>
                                <h5>Asset IMEI search</h5>
                            </router-link>
                        </div>

                        <!-- Outbound Shipments -->
                        <div class="card-link-container">
                            <router-link :to="{ name: 'outboundShipments'}" class="card card-body card-link vertical">
                                <icon-outbound-shipment size="2x"></icon-outbound-shipment>
                                <h5>Outbound shipments</h5>
                            </router-link>
                        </div>

                        <!-- Pending in-house repairs -->
                        <div class="card-link-container">
                            <router-link :to="{ name: 'inHouseRepairs'}" class="card card-body card-link vertical">
                                <icon-in-house-repair size="2x"></icon-in-house-repair>
                                <h5>Pending in-house repairs</h5>
                            </router-link>
                        </div>
                    </div>
                </template>

            </div>

            <!-- Policies and Procedures -->
            <a href="https://drive.google.com/open?id=1hfMYQwACpJfLcG_37VwyxhfhlzLkjeAV" target="_blank" class="btn btn-solid-secondary btn-rounded m-auto px-4 py-2 text-sm icon-right">Policies and Procedures <i class="fa fa-external-link"></i></a>

        </div>

        <!-- TODO: Display Notifications -->

    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'

    export default {

        mounted() {
            if (this.isTechnician) {
                this.loadTodaysJobs();
            }
        },

        computed:{
            ...mapGetters([
                "isInHouseTechnician",
                "isSuperAdmin",
                "isTechnician",
                "jobs",
                "repairKitsPicked",
                "repairKitsToBePicked",
                "user"
            ]),
        },

        methods: {
            ...mapActions([
                "displayToast",
                "loadTodaysJobs",
                "loadTodaysRepairKits"
            ]),

        }
    }
</script>